import authService from './authService';
import { DashboardCalendar, DashboardNotifications, DashboardSummary } from '../types/dashboard';
import { ApiResponse } from '../types/common';

class DashboardService {
  /**
   * Busca o resumo do dashboard por perfil (painéis habilitados + dados).
   */
  async getSummary(): Promise<DashboardSummary> {
    const apiClient = await authService.getApiClient();
    const response = await apiClient.get('/dashboard/summary');

    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(err?.message || 'Falha ao carregar o resumo do dashboard');
    }

    const data: ApiResponse<DashboardSummary> = await response.json();
    return data.data!;
  }

  /**
   * Busca o calendário de prioridades do mês (YYYY-MM; vazio = mês corrente).
   */
  async getCalendar(month?: string): Promise<DashboardCalendar> {
    const apiClient = await authService.getApiClient();
    const query = month ? `?month=${encodeURIComponent(month)}` : '';
    const response = await apiClient.get(`/dashboard/calendar${query}`);

    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(err?.message || 'Falha ao carregar o calendário');
    }

    const data: ApiResponse<DashboardCalendar> = await response.json();
    return data.data!;
  }

  /**
   * Busca as notificações do sino (pedidos prioritários hoje/amanhã +
   * recebimentos de produto personalizado por 2 dias úteis).
   */
  async getNotifications(): Promise<DashboardNotifications> {
    const apiClient = await authService.getApiClient();
    const response = await apiClient.get('/dashboard/notifications');

    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(err?.message || 'Falha ao carregar as notificações');
    }

    const data: ApiResponse<DashboardNotifications> = await response.json();
    return data.data!;
  }
}

export default new DashboardService();
